import script from "./VDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./VDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./VDropdown.vue?vue&type=style&index=0&id=d042f3ac&lang=scss&scoped=true"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d042f3ac"]])

export default __exports__